<template>
  <div class="row">
    <template v-if="isEditable">
      <div class="col-12">
        <EducationForm :switcher.sync="isEditable" mode="edit" :sourceEducation="body" />
      </div>
    </template>
    <template v-else>
      <div class="col-11">
        <p class="w-sbold mb-0">{{ body.location }}</p>
        <p class="w-medium dark-gray mb-0">{{ body.field_study }}</p>
        <p class="w-medium dark-gray mb-0">
          {{body.start_date.split('-')[0]}}
          -
          {{body.end_date.split('-')[0]}}
        </p>
      </div>
      <div class="col-1">
        <div class="d-flex justify-content-end">
          <Dropdown theme="light" v-model="switcherActions">
            <template v-slot:toggle>
              <button
                @click="switcherActions = !switcherActions"
                class="c-link c-link--black">
                <Icon icon="entypo:dots-three-vertical" />
              </button>
            </template>
            <template v-slot:menu>
              <ul>
                <li>
                  <button @click="openActions('edit')" class="d-flex w-100">
                    <Icon icon="la:pen" class="fs-18 me-2" />
                    <span class="fs-14 w-sbold">Editar</span>
                  </button>
                </li>
                <li color="alert">
                  <button @click="openActions('delete')" class="d-flex w-100">
                    <Icon icon="ci:trash-full" class="fs-18 me-2" />
                    <span class="fs-14 w-sbold">Eliminar</span>
                  </button>
                </li>
              </ul>
            </template>
          </Dropdown>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
      switcherActions: false,

      isEditable: false,
    };
  },
  components: {
    Dropdown: () => import(/* webpackChunkName: "dropdown" */'@/components/ui/Dropdown.vue'),
    EducationForm: () => import(/* webpackChunkName: "profile-education-form" */'@/components/panel/edit/EducationForm.vue'),
  },
  props: {
    body: Object,
  },
  methods: {
    openActions(action) {
      this.switcherActions = false;

      if (action === 'edit') {
        this.isEditable = true;
      }
    },
  },
};
</script>
